/**
 * Created by Ning Jiang on 4/6/2017.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SequentiallyBetWayInitialWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/sequentially/SequentiallyBetWayInitialWPController";
import {Timeline} from "gsap";
import {WixxReelSymbol} from "../../reelsymbol/WixxReelSymbol";
import {WixxParsedGameData} from "../../server/data/WixxParsedGameData";
import {WixxHelper} from "../../utils/WixxHelper";
import {Wixx} from "../../Wixx";
import {WixxGameConfig} from "../../WixxGameConfig";
import {WixxSoundConfig} from "../../WixxSoundConfig";
import {WinWaysWonIndicator} from "../winwayswon/WinWaysWonIndicator";
import {WixxInitialWPView} from "./WixxInitialWPView";

export class WixxInitialWPController extends SequentiallyBetWayInitialWPController {

    private _symbolDelay:number = 0.1;
    private _betWayDelay:number = 0.5;
    private _winNumberTotalDuration:number = 2;
    private _winNumberFadeOutDuration:number = 0.3;
    private _winNumberOffsetY:number = -100;

    private _reelsNum:number;
    private _symbolsNum:number;

    private _view:WixxInitialWPView;
    private _symbolWinStates:boolean[][];
    private _winWaysWon:number = 0;
    private _wixxGameData:WixxParsedGameData;
    private _hasFeature:boolean;

    // #270
    private _winBelowStake: boolean = false;

    constructor(indexes:[number, number]) {
        super(indexes, {
            name : "WixxInitialWin",
            hasWinCountUp : true,
            skippable : true
        });

        this._reelsNum = GameConfig.instance.REELS_NUM;
        this._symbolsNum = GameConfig.instance.SYMBOLS_NUM_IN_REEL[2];

        this._view = new WixxInitialWPView();

        this.addTweakModuleSlider({
            text : "Symbol Delay",
            minValue : 0.01,
            maxValue : 2.0,
            startValue : this._symbolDelay,
            onValueChangeCallback : (text:string, newValue:number) => this.onSymbolDelayChanged(newValue)
        });

        this.addTweakModuleSlider({
            text : "Bet Way Delay",
            minValue : 0.01,
            maxValue : 2.0,
            startValue : this._betWayDelay,
            onValueChangeCallback : (text:string, newValue:number) => this.onBetWayDelayChanged(newValue)
        });

        this.addTweakModuleSlider({
            text : "Win Number Offset Y",
            minValue : 0,
            maxValue : -500,
            startValue : this._winNumberOffsetY,
            onValueChangeCallback : (text:string, newValue:number) => this.onWinNumberOffsetYChanged(newValue)
        });

        this.addTweakModuleSlider({
            text : "Win Number Total Duration",
            minValue : 0.5,
            maxValue : 5,
            startValue : this._winNumberTotalDuration,
            onValueChangeCallback : (text:string, newValue:number) => this.onWinNumberTotalDurationChanged(newValue)
        });

        this.addTweakModuleSlider({
            text : "Win Number FadeOut Duration",
            minValue : 0.1,
            maxValue : 3,
            startValue : this._winNumberFadeOutDuration,
            onValueChangeCallback : (text:string, newValue:number) => this.onWinNumberFadeOutDurationChanged(newValue)
        });
    }

    private onSymbolDelayChanged(newValue:number):void {
        this._symbolDelay = newValue;
    }

    private onBetWayDelayChanged(newValue:number):void {
        this._betWayDelay = newValue;
    }

    private onWinNumberOffsetYChanged(newValue:number):void {
        this._winNumberOffsetY = newValue;
    }

    private onWinNumberTotalDurationChanged(newValue:number):void {
        this._winNumberTotalDuration = newValue;
    }

    private onWinNumberFadeOutDurationChanged(newValue:number):void {
        this._winNumberFadeOutDuration = newValue;
    }

    protected parseFeatureGameData(data:WixxParsedGameData):void {
        if(super.parseFeatureGameData) {
            super.parseFeatureGameData(data);
        }

        this._wixxGameData = data;
        this._hasFeature = data.symbolToWildRespinActive
            || data.multiplierRespinActive
            || data.stackedReelFourRespinActive;

        // #270
        this._winBelowStake = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
    }

    protected playAllNoWinSymbols(timeline:Timeline):void {
        this._symbolWinStates = ArrayHelper.initArrayWithValues<boolean[]>(this._reelsNum, () => {
            return ArrayHelper.initArrayWithValues<boolean>(this._symbolsNum, () => {return false;})
        });

        for(let l:number = 0; l < this._betWinsData!.length; l++) {
            const betWayWinData:IBetWayWinData = <IBetWayWinData>this._betWinsData![l];
            for(let i:number = 0; i < betWayWinData.reelWinPositions.length; i++) {
                for(let j:number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                    if(betWayWinData.reelWinPositions[i][j]) {
                        this._symbolWinStates[i][j] = true;
                    }
                }
            }
        }

        let noWinSymbol:StateReelSymbol | null;
        for(let i:number = 0; i < this._symbolWinStates.length; i++) {
            for(let j:number = 0; j < this._symbolWinStates[i].length; j++) {
                if(this._symbolWinStates[i][j]) {
                    continue;
                }

                noWinSymbol = Reels.getSymbol(i, j);
                if(noWinSymbol == null) {
                    continue;
                }

                timeline.add(noWinSymbol.changeState({
                    state : WixxGameConfig.instance.SYMBOL_STATES.noWin!,
                    fadeInDuration : 1.5
                }), 0);
            }
        }
    }

    protected addSingleBetWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number):number {
        const delay:number = super.addSingleBetWinAnimationToTimeline(betWayWinData, timeline, startTime);

        this._winWaysWon += betWayWinData.numberOfCombinations;
        const winWaysWon = this._winWaysWon;

        timeline.add(() => {EventHandler.dispatchEvent(new GameEvent(WinWaysWonIndicator.SHOW_WIN_WAYS_WON, winWaysWon))}, startTime + delay);

        return delay + this._betWayDelay;
    }

    protected addSymbolWinAnimationToTimeline(betWayWinData:IBetWayWinData, timeline:Timeline, startTime:number, symbol:WixxReelSymbol, reelId:number, symbolId:number):number {
        const position:[number, number] = Helper.getSymbolPositions(reelId, symbolId);
        const symbolDuration:number = super.addSymbolWinAnimationToTimeline(betWayWinData, timeline, startTime, symbol, reelId, symbolId);

        // #270
        if (!this._winBelowStake) {
            this._view.addWinBurstToTimeline(timeline, startTime, symbolDuration, position, WixxHelper.isBoostedSymbol(symbol.symName));
        }

        // Special W symbols with multiplier.
        if(this._wixxGameData.multiplierRespinActive) {
            if((this._wixxGameData.symbolToWildRespinActive && symbol.symName.indexOf("M1") > -1) || symbol.symName === ReelSymbolName.WILD) {
                if(WixxHelper.isMidSymbol(betWayWinData.symbol)) {
                    timeline.add(symbol.playMultiplier(), startTime);
                } else {
                    timeline.add(() => symbol.hideMultiplier(0), startTime);
                }
            }
        }

        return this._symbolDelay;
    }


    protected addWinCountUpToTimeline(timeline:gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax):void {
        const duration = this.getWinCountUpDuration(timeline);
        timeline.add(Wixx.winCountUp.getCountUpAnimation(0, this._wixxGameData.singleWin, duration), 0);
    }

    protected getWinCountUpDuration(timeline:Timeline):number {
        return WixxSoundConfig.getNormalWinSoundDuration(this._gameData!.currentWinRatioConfig);
    }

    protected startWinPresentation():void {
        super.startWinPresentation();

        // #270
        if (!this._winBelowStake) {
            const winSound: string | null = WixxSoundConfig.getNormalWinSoundName(this._gameData!.currentWinRatioConfig);
            if (winSound) {
                SlotGame.sound.playEffect(winSound);
            }

            const winCountUpSound: string | null = WixxSoundConfig.getNormalWinCountUpSoundName(this._gameData!.currentWinRatioConfig);
            if (winCountUpSound) {
                SlotGame.sound.playEffect(winCountUpSound);
            }
        }

        if(Wixx.particles != null) {
            Wixx.particles.play(1.5 * (this._hasFeature ? 1.8 : 1));
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        super.stopWinPresentation(isAborted);

        this._view.stopWinPresentation();
        EventHandler.dispatchEvent(new GameEvent(WinWaysWonIndicator.SHOW_WIN_WAYS_WON));

        this._winWaysWon = 0;

        let noWinSymbol:StateReelSymbol | null;
        for(let i:number = 0; i < this._symbolWinStates.length; i++) {
            for(let j:number = 0; j < this._symbolWinStates[i].length; j++) {
                if(this._symbolWinStates[i][j]) {
                    continue;
                }

                noWinSymbol = Reels.getSymbol(i, j);
                if(noWinSymbol == null) {
                    continue;
                }

                noWinSymbol.changeState({
                    state : WixxGameConfig.instance.SYMBOL_STATES.noWin!
                });
            }
        }
        Wixx.winCountUp.getEndingAnimation(this._wixxGameData.singleWin);
        SlotGame.winFieldController.showWinField(this._wixxGameData.totalWin);

        // if(isAborted) {
        //     this.stopWinSound();
        // }

        if(Wixx.particles != null) {
            Wixx.particles.play(1);
        }
    }

    private stopWinSound():void {
        const winCountUpSound:string | null = WixxSoundConfig.getNormalWinCountUpSoundName(this._gameData!.currentWinRatioConfig);
        if(winCountUpSound) {
            SlotGame.sound.stopEffect(winCountUpSound);
        }

        const winSound:string | null = WixxSoundConfig.getNormalWinSoundName(this._gameData!.currentWinRatioConfig);
        if(winSound) {
            SlotGame.sound.stopEffect(winSound);
        }
    }
}